import { render, staticRenderFns } from "./lookview.vue?vue&type=template&id=3ecc86c8&slot=title"
import script from "./lookview.vue?vue&type=script&lang=js"
export * from "./lookview.vue?vue&type=script&lang=js"
import style0 from "./lookview.vue?vue&type=style&index=0&id=3ecc86c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports